import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { config } from 'src/app/config/api.config';
import { Admis } from 'src/app/model/Admis';
import { Apprenant } from 'src/app/model/Apprenant';

import { ApprenantFode } from 'src/app/model/apprenantFode.model';
import { Statistics } from 'src/app/model/statistics.model';
import { Beneficiary } from 'src/app/model/beneficiary.model';
import { TestQualification } from 'src/app/model/TestQualification';
import { TestQualificationToSend } from 'src/app/model/TestQualificationToSend';
import { CusstomResponseDTO } from 'src/app/model/dto/custom-response';
import { Manager } from 'src/app/model/Manager';
import { PaginatedResponse } from 'src/app/interfaces/paginateResponse.interface';
import { PersonalCompany } from 'src/app/model/personal.company';
import {
  CourseType,
  EmailCertificationResponse,
} from 'src/app/model/email-certification.model';

@Injectable({
  providedIn: 'root',
})
export class UtilisateursService {
  constructor(private httpClient: HttpClient) {}

  private buildPaginationParams(
    page: number = 0,
    size: number = 10,
  ): HttpParams {
    return new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
  }

  getListApprenant(): Observable<Apprenant[]> {
    return this.httpClient.get<Apprenant[]>(
      `${config.apiBaseUrl}/apprenent/allstudent`,
    );
  }

  /*getListApprenantFromFode(): Observable<ApprenantFode[]> {
    return this.httpClient.get<ApprenantFode[]>(
      `${config.apiBaseUrl}/apprenent/allstudent`
    );
  }*/

  getListApprenantFromFode(
    page: number = 0,
    size: number = 10,
    search: string = '',
  ): Observable<PaginatedResponse<ApprenantFode>> {
    const params = this.buildPaginationParams(page, size).set('search', search);
    return this.httpClient.get<PaginatedResponse<ApprenantFode>>(
      `${config.apiBaseUrl}/apprenent/allstudent`,
      { params },
    );
  }

  // getStudentsByCertificateId
  /*getStudentsByCertificateId(certificatId: number): Observable<ApprenantFode[]> {
    return this.httpClient.get<ApprenantFode[]>(
      `${config.apiBaseUrl}/apprenent/studentbycertificate/${certificatId}`
    );
  }*/

  // getStudentsByCertificateId with pagination

  getStudentsByCertificateId(
    label: string,
    courseType: CourseType,
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<ApprenantFode>> {
    const params = this.buildPaginationParams(page, size)
      .set('label', label)
      .set('courseType', courseType);

    return this.httpClient.get<PaginatedResponse<ApprenantFode>>(
      `${config.apiBaseUrl}/apprenent/students-by-certificate`,
      { params },
    );
  }

  // getStudentCertified (recup list student certified)
  /*public getStudentCertified(): Observable<ApprenantFode[]> {
    return this.httpClient.get<ApprenantFode[]>(
      `${config.apiBaseUrl}/apprenent/studentsCertified`
    );
  }*/

  // getStudentCertified with pagination
  getStudentCertified(
    courseType?: CourseType | null,
    label?: string | null,
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<ApprenantFode>> {
    let params = this.buildPaginationParams(page, size);

    if (courseType) {
      params = params.set('courseType', courseType);
    }
    if (label) {
      params = params.set('label', label);
    }

    return this.httpClient.get<PaginatedResponse<ApprenantFode>>(
      `${config.apiBaseUrl}/apprenent/studentsCertified`,
      { params },
    );
  }

  getStudentEnhanced(
    courseType?: CourseType | null,
    label?: string | null,
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<ApprenantFode>> {
    let params = this.buildPaginationParams(page, size);

    if (courseType) {
      params = params.set('courseType', courseType);
    }
    if (label) {
      params = params.set('label', label);
    }
    return this.httpClient.get<PaginatedResponse<ApprenantFode>>(
      `${config.apiBaseUrl}/apprenent/enhanced`,
      { params },
    );
  }
  getStudentAipen(
    courseType?: CourseType | null,
    label?: string | null,
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<ApprenantFode>> {
    let params = this.buildPaginationParams(page, size);

    if (courseType) {
      params = params.set('courseType', courseType);
    }
    if (label) {
      params = params.set('label', label);
    }

    return this.httpClient.get<PaginatedResponse<ApprenantFode>>(
      `${config.apiBaseUrl}/apprenent/inseres`,
      { params },
    );
  }

  exportStudents(
    flag: 'CERTIFIED' | 'ENHANCED' | 'INSERES' | null,
    gender: 'FEMALE' | 'MALE' | null,
    courseType: string | null,
    label: string | null,
    ageRange: string | null,
    status: string | null,
    country: string | null,
    region: string | null,
    cohorte: string | null,
    isDistinct: boolean
  ): Observable<HttpResponse<Blob>> {

    let params = new HttpParams();
    if (flag !== null) {
      params = params.set('flag', flag);
    }

    if (gender) {
      params = params.set('gender', gender);
    }

    if (courseType) {
      params = params.set('courseType', courseType);
    }

    if (label) {
      params = params.set('label', label);
    }

    if (ageRange) {
      params = params.set('ageRange', ageRange);
    }

    if (status) {
      params = params.set('status', status);
    }
    if (country) {
      params = params.set('country', country);
    }
    if (region) {
      params = params.set('region', region);
    }
    if (cohorte) {
      params = params.set('cohorte', cohorte);
    }

    params = params.set('isDistinct', isDistinct);

    return this.httpClient.get(
      `${config.apiBaseUrl}/apprenent/export`,
      {
        params,
        observe: 'response',
        responseType: 'blob'
      }
    );
  }

  allCohorts(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${config.apiBaseUrl}/apprenent/cohorts`);
  }

  getCertifiableCourseByEmail(
    email: string,
  ): Observable<EmailCertificationResponse> {
    return this.httpClient.get<EmailCertificationResponse>(
      `${config.apiBaseUrl}/dashboard/certifiable/${email}`,
    );
  }

  getAllCertificate(courseType: string): Observable<any> {
    return this.httpClient.get<any>(`${config.apiBaseUrl}/certificate/liste`, {
      params: {
        courseType: courseType,
      },
    });
  }

  //recup list students certified by certicate  id
  public getListCertifiedByCertificateId(
    ids: number,
  ): Observable<ApprenantFode[]> {
    return this.httpClient
      .get<
        ApprenantFode[]
      >(`${config.apiBaseUrl}/apprenent/listCertifiedByCertificateId/${ids}`)
      .pipe(
        catchError((error: any) => {
          console.error(
            'Erreur lors de la récupération des étudiants certifiés par ID de certificat : ',
            error,
          );
          return throwError(error);
        }),
      );
  }
  public getCandidatureStatistics(cohorte: string): Observable<Statistics> {
    return this.httpClient.get<Statistics>(
      `${
        config.apiBaseUrl
      }/jotform/candidature/candidatureStatistics?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }

  public getAdmittedByFamilyAndGender(): Observable<any> {
    return this.httpClient.get<any>(`${config.apiBaseUrl}/deliberation/admis`);
  }

  getRepecherByFamilyAndGender(cohorte: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/deliberation/repecher`,
      {
        params: { cohorte },
      },
    );
  }

  public getNoAdmitted(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/deliberation/list-non-admis`,
    );
  }

  public getAdmittedByFamily(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/deliberation/admis-by-family`,
    );
  }

  /*   uploadFileToAlfresco(
    fichier: FormData,
    iuf: string,
    documentType: string
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${config.apiBaseUrl}/alfresco/upload/${documentType}/${iuf}`,
      fichier
    );
  }
 */
  uploadFileToAlfresco(fichier: FormData, iuf: string): Observable<any> {
    return this.httpClient.post<any>(
      `${config.apiBaseUrl}/alfresco/upload/${iuf}`,
      fichier,
    );
  }

  getPublicDocuments(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/alfresco/documents/public`,
    );
  }

  getApprenantDocuments(iuf: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/alfresco/documents/${iuf}`,
    );
  }

  deleteDocument(nodeId: string): Observable<any> {
    return this.httpClient.delete<any>(
      `${config.apiBaseUrl}/alfresco/delete/${nodeId}`,
    );
  }

  getMyPorfolio(iuf: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/alfresco/portfolio/${iuf}`,
    );
  }
  deleteDiplome(diplome_id: number): Observable<any> {
    return this.httpClient.delete<any>(
      `${config.apiBaseUrl}/alfresco/diplomes/delete/${diplome_id}`,
    );
  }
  updateDiplome(
    fichier: FormData,
    diplome_id: number,
    iuf: string,
  ): Observable<any> {
    return this.httpClient.put<any>(
      `${config.apiBaseUrl}/alfresco/diplome/update/${diplome_id}/${iuf}`,
      fichier,
    );
  }

  public countAdmis(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/deliberation/count-admis`,
    );
  }

  public countNoAdmis(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/deliberation/count-nonadmis`,
    );
  }

  public countAdmisNoAdmis(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/deliberation/count-admis-noadmis`,
    );
  }

  saveTestPersonnality(codeTest: string, iuf: string): Observable<any> {
    const requestBody = { codeTest: codeTest };
    return this.httpClient.put<any>(
      `${config.apiBaseUrl}/profilTest/saveTestPersonnality/${iuf}`,
      requestBody,
    );
  }

  public getDataTestPersonnality(code: String): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/profilTest/codeTest?codeTest=${code}`,
    );
  }

  public getExistingDataByIuf(iuf: String): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/profilTest/getExisting?iuf=${iuf}`,
    );
  }

  getAdmittedByCityAndGender(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/deliberation/admis-by-ville`,
    );
  }

  getAdmittedByCityAndGenderHSG(cohorte: string): Observable<any> {
    return this.httpClient.get<any>(
      `${
        config.apiBaseUrl
      }/deliberation/admis-by-villeHSG?cohorte=${encodeURIComponent(cohorte)}`,
    );
  }
  getCertificatedHorsSiguiStat(cohorte: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/deliberation/admisHSG?cohorte=${encodeURIComponent(
        cohorte,
      )}`,
    );
  }
  getAdmisHorsSiguiStat(cohorte: string): Observable<any> {
    return this.httpClient.get<any>(
      `${
        config.apiBaseUrl
      }/deliberation/list-of-admisHSG?cohorte=${encodeURIComponent(cohorte)}`,
    );
  }

  getConfirmed(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/deliberation/confirmation`,
    );
  }

  public getChoiceCertificat(
    email: string,
    testQualif: TestQualificationToSend,
  ): Observable<any> {
    return this.httpClient.put<void>(
      `${config.apiBaseUrl}/testQualification/updateCertificateTest?email=${email}`,
      testQualif,
    );
  }

  public getListTestQualification(email: string): Observable<any> {
    return this.httpClient.get<TestQualification>(
      `${config.apiBaseUrl}/testQualification/listTestQualification/${email}`,
    );
  }

  createManager(managerToCreate: Manager): Observable<CusstomResponseDTO> {
    return this.httpClient.post<CusstomResponseDTO>(
      `${config.apiBaseUrl}/usermanager/create`,
      managerToCreate,
    );
  }

  getListRoles(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/usermanager/roles/All`,
    );
  }

  public createPersonalCompany(personal: PersonalCompany): Observable<any> {
    return this.httpClient.post<any>(
      `${config.apiBaseUrl}/companies/CreatePersonalCompany`,
      personal,
    );
  }

  public getAllCertificateMentors(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/mentoratCertificate/list`,
    );
  }
  public getPartenaireBenin(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/applicationOffTrack/benin-roles`,
    );
  }

  getApprenantsBeninPaged(
    iuf: string,
    page: number = 0,
    size: number = 10,
    gender?: string,
    certified?: boolean,
    enhanced?: boolean,
    employed?: boolean,
    searchTerm?: string,
    certificateId?: number,
  ): Observable<PaginatedResponse<ApprenantFode>> {
    let params = this.buildPaginationParams(page, size);

    if (gender) params = params.set('gender', gender);
    if (certified !== undefined)
      params = params.set('certified', certified.toString());
    if (enhanced !== undefined)
      params = params.set('enhanced', enhanced.toString());
    if (employed !== undefined)
      params = params.set('employed', employed.toString());
    if (searchTerm) params = params.set('searchTerm', searchTerm);
    if (certificateId)
      params = params.set('certificateId', certificateId.toString());

    return this.httpClient.get<PaginatedResponse<ApprenantFode>>(
      `${config.apiBaseUrl}/foreignManager/${iuf}/apprenants`,
      { params },
    );
  }

  getAllAvailableCertificatesBenin(iuf: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${config.apiBaseUrl}/foreignManager/${iuf}/available-certificates`,
    );
  }

  getCountries(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${config.apiBaseUrl}/countries`);
  }

  getUemoaCountries(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${config.apiBaseUrl}/countries/uemoa`);
  }

  getCountryByStructure(structure: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/foreignManager/country`,
      {
        params: { structure },
      },
    );
  }
}
